import { frontendURL } from 'dashboard/helper/URLHelper';
import Index from './Index.vue';

// Chỉ quản trị: chi tiêu quảng cáo và việc quy nguồn khách là thông tin kinh
// doanh. Đây chỉ là lớp giấu lối vào — controller phía Rails cũng chặn, vì giấu
// menu không phải là phân quyền.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm'),
    name: 'bonboz_crm_index',
    meta: { permissions: ['administrator'] },
    component: Index,
  },
];
